export default {
    borderRadius: '4px',
    light: {
        type: 'light',
        background: '#fff',
        button: '#2D5D7C;',
        secondaryBackground: '#fff',
        primaryColor: '#822ed8',
        primaryHoverColor: '#d4bbef',
        fontColor: 'rgb(0,0,0, 0.5)',
        borderColor: '#d9d9d9',
        dateFormat: 'YYYY-MM-DD',
        colors: [
            '#B12AB8',
            '#FFA4FF',
            '#007BF8',
            '#BC8FBC',
            '#6B77A9',
            '#008EED',
            '#6395F9',
            '#009E9B',
            '#0DD9A4',
            '#6B77A9',
            '#8E5EA2',
            '#FFE7FF',
            '#AA85A9',
            '#E8C3B9',
            '#3E95CD',
            '#5ABAB5',
            '#0DD9A4',
            '#056950',
            '#FB7716',
            '#B6A6B5',
            '#8E5EA2',
            '#E8C3B9'
        ]
    },
    dark: {
        type: 'dark',
        button: '#1f8efa',
        background: '#2f3b52',
        secondaryBackground: '#242e42',
        panelBackground: '#2f3b52',
        primaryColor: '#672cb9',
        primaryHoverColor: '#20293c',
        fontColor: '#a8afbc',
        borderColor: 'rgba(0,0,0, 0.2)',
        dateFormat: 'DD-MM-YYYY',
        colors: [
            '#B12AB8',
            '#FFA4FF',
            '#007BF8',
            '#BC8FBC',
            '#6B77A9',
            '#008EED',
            '#6395F9',
            '#009E9B',
            '#0DD9A4',
            '#6B77A9',
            '#8E5EA2',
            '#FFE7FF',
            '#AA85A9',
            '#E8C3B9',
            '#3E95CD',
            '#5ABAB5',
            '#0DD9A4',
            '#056950',
            '#FB7716',
            '#B6A6B5',
            '#8E5EA2',
            '#E8C3B9'
        ]
    }
};
